import { connect, MapStateToProps } from 'react-redux';
import { getEditorDraft as getEditorDraftNew } from '@wix/da-editor-tiptap/pkg/clientDrafts/selectors';
import { CommentContextProviderProps as Props } from './CommentContextProvider';
import { isInitialized, getCommentState } from '../../redux/selectors';
import { generateReplyEditorId } from '../../utils';

type StateProps = Pick<Props, 'comment' | 'hasReplyDraft'>;
type OwnProps = Omit<Props, 'hasReplyDraft'>;

const getPropWithSelector = (state, commentId, selector, defaultValue) => {
  if (isInitialized(commentId)(state)) {
    return selector(commentId)(state);
  }
  return defaultValue;
};

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state,
  ownProps
) => {
  return {
    comment: getPropWithSelector(
      state,
      ownProps.comment.commentId,
      getCommentState,
      ownProps.comment
    ),
    hasReplyDraft: !!getEditorDraftNew(
      state,
      generateReplyEditorId(ownProps.comment)
    ),
  };
};

export default connect(mapStateToProps);
